import * as React from 'react';
import { Redirect } from 'react-router-dom';

import { saveLoginRedirectPath } from '../helpers/local-storage';

export const LoginRedirect = () => {
    saveLoginRedirectPath();
    return <Redirect to={'/login'} />;
};
